import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiGrid, FiDatabase, FiFileText, FiUsers, FiSettings, FiUser, FiLogOut, FiActivity, FiHome, FiBarChart2, FiMenu, FiX, FiCpu, FiFolder } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const SidebarContent = ({ user, isActive, logout }) => (
  <>
    <div className="sidebar-section">Menu Utama</div>
    <ul className="sidebar-nav">
      <li><Link to="/dashboard" className={isActive('/dashboard')}><FiGrid size={17} /> Ringkasan</Link></li>
      <li><Link to="/dashboard/datasets" className={isActive('/dashboard/datasets')}><FiDatabase size={17} /> Dataset</Link></li>
      <li><Link to="/dashboard/berita" className={isActive('/dashboard/berita')}><FiFileText size={17} /> Berita</Link></li>
      <li><Link to="/dashboard/analitik" className={isActive('/dashboard/analitik')}><FiBarChart2 size={17} /> Analitik</Link></li>
      <li><Link to="/dashboard/ai" className={isActive('/dashboard/ai')}><FiCpu size={17} /> NgadhuAI</Link></li>
    </ul>

    {user?.role === 'admin' && (
      <>
        <div className="sidebar-section">Administrasi</div>
        <ul className="sidebar-nav">
          <li><Link to="/dashboard/users" className={isActive('/dashboard/users')}><FiUsers size={17} /> Kelola User</Link></li>
          <li><Link to="/dashboard/kategori" className={isActive('/dashboard/kategori')}><FiFolder size={17} /> Kelola Kategori</Link></li>
          <li><Link to="/dashboard/organisasi" className={isActive('/dashboard/organisasi')}><FiSettings size={17} /> Organisasi</Link></li>
          <li><Link to="/dashboard/activity" className={isActive('/dashboard/activity')}><FiActivity size={17} /> Log Aktivitas</Link></li>
        </ul>
      </>
    )}

    <div className="sidebar-section">Akun</div>
    <ul className="sidebar-nav">
      <li><Link to="/dashboard/profil" className={isActive('/dashboard/profil')}><FiUser size={17} /> Profil Saya</Link></li>
      <li><button onClick={logout} style={{ color: 'var(--danger)' }}><FiLogOut size={17} /> Keluar</button></li>
    </ul>
  </>
);

const DashboardLayout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isActive = (path) => location.pathname === path ? 'active' : '';

  const handleLogout = () => { logout(); navigate('/'); };

  useEffect(() => { setMobileMenuOpen(false); }, [location]);

  return (
    <div>
      {/* Dashboard Navbar */}
      <nav className="navbar scrolled" style={{ background: 'white' }}>
        <div className="navbar-inner">
          <Link to="/" className="navbar-brand">
            <div className="brand-icon">N</div>
            <div>NGADHU<span className="brand-sub">Dashboard</span></div>
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <Link to="/" className="btn btn-ghost btn-sm"><FiHome size={14} /> Beranda</Link>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div className="user-avatar">{user?.nama?.charAt(0)?.toUpperCase()}</div>
              <div className="desktop-only text-sm">
                <div style={{ fontSize: '0.85rem', fontWeight: 600 }}>{user?.nama}</div>
                <div style={{ fontSize: '0.7rem', color: 'var(--gray-400)', textTransform: 'capitalize' }}>{user?.role}</div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className="dashboard-layout">
        <div className="dashboard-mobile-header">
          <button className="btn btn-ghost btn-icon" onClick={() => setMobileMenuOpen(true)}>
            <FiMenu size={24} />
          </button>
          <div style={{ fontWeight: 700, fontSize: '1rem', color: 'var(--primary-700)' }}>NGADHU</div>
          <div className="user-avatar" style={{ width: 32, height: 32 }}>{user?.nama?.charAt(0)?.toUpperCase()}</div>
        </div>

        <AnimatePresence>
          {mobileMenuOpen && (
            <>
              <motion.aside 
                className="sidebar mobile-active"
                initial={{ x: -280 }}
                animate={{ x: 0 }}
                exit={{ x: -280 }}
                transition={{ type: 'spring', damping: 25, stiffness: 200 }}
                style={{ zIndex: 2100 }}
              >
                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '1rem' }}>
                  <button onClick={() => setMobileMenuOpen(false)} style={{ background: 'none', border: 'none', color: 'var(--gray-400)' }}><FiX size={24} /></button>
                </div>
                <SidebarContent user={user} isActive={isActive} logout={handleLogout} />
              </motion.aside>
              <div className="mobile-overlay" onClick={() => setMobileMenuOpen(false)} />
            </>
          )}
        </AnimatePresence>

        <aside className="sidebar desktop-sidebar">
          <SidebarContent user={user} isActive={isActive} logout={handleLogout} />
        </aside>

        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
